/**
 * Initial state of the desktop sidebar (SHELL-06 AC 2/3): the `sidebar_state`
 * cookie written by `ui/sidebar.tsx` is now also read; 768–1023px always
 * starts as the icon rail.
 */
export const SIDEBAR_COOKIE_NAME = 'sidebar_state';

/** `true`/`false` from the cookie; `null` when absent or not a boolean. */
export function parseSidebarCookie(cookieHeader: string): boolean | null {
  for (const part of cookieHeader.split(';')) {
    const [name, ...rest] = part.trim().split('=');
    if (name !== SIDEBAR_COOKIE_NAME) continue;
    const value = rest.join('=');
    if (value === 'true') return true;
    if (value === 'false') return false;
    return null;
  }
  return null;
}

export function resolveInitialSidebarOpen(input: {
  cookieValue: boolean | null;
  isTablet: boolean;
}): boolean {
  if (input.isTablet) return false;
  return input.cookieValue ?? true;
}
